import { Button } from "@material-ui/core";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_DEFALUT } from ".";
import { TableColumn, TableWithCollapse } from "../../../lib/DataTable";
import { useTableWithCollapse } from "../../../lib/DataTable/customHooks";
import { RootStateType } from "../../../store/reducers";
import { BANK } from "../../../store/types/nct";
import { updateMultiBankDetails } from "../../../store/actions/nct";
import { BANK_ACCOUNT_DETAILS } from "../../../utils/constants";
import { ConsolidateTableRowType } from "../ConsolidationFolios/types";
import { ActionHeader, BackArrow } from "../UpdateNominee/SelectedFolios";
import en from "../../../lang/en-us";
import Image from "../../Image";
const { dashboard } = en;

type bankMandateProps = {
  accountNo: string;
  accountType: string;
  branch: string;
  city: string;
  default?: string;
  id: string;
  ifsc: string;
  micr: string;
  name: string;
  neftIfsc: string;
  pincode: number | string;
};

export const Columns: TableColumn[] = [
  {
    field: "bank",
    headerName: "BANK NAME",
    valueGetter: ({ row }) => row?.name,
    width: 200,
  },
  {
    field: "id",
    headerName: "ACCOUNT NUMBER",
    valueGetter: ({ row }) => row?.accountNo,
    width: 200,
  },
  {
    field: "ifsc",
    headerName: "IFSC",
    valueGetter: ({ row }) => row?.ifsc || row?.neftIfsc,
    width: 200,
  },
  {
    field: "investorName",
    headerName: "PRIMARY HOLDER",
    valueGetter: ({ row }) =>
      (row?.investorName || "").toUpperCase() || "Not Available",
    width: 100,
  },
];
function BankMandateDeleteSelected(props: any) {
  const {
    targetFunds = [],
    actionType,
  }: { targetFunds: ConsolidateTableRowType[]; actionType: string } =
    props.location.state || {};

  const [tablesData, setTablesData] = useState<ConsolidateTableRowType[]>([]);

  const {
    selectedRows,
    setSelectedRows,
    filterType,
    filteredData,
    ...filters
  } = useTableWithCollapse<any>({
    initialSelectionModal: {},
  });

  useEffect(() => {
    const initState = targetFunds.reduce(
      (prev, curr, index: number) => ({
        ...prev,
        [`table${index}`]: [],
      }),
      {}
    );
    setTablesData(targetFunds);
    setSelectedRows(initState);
  }, [targetFunds]);

  useEffect(() => {
    if (!props.location.state) {
      props.history.push("/");
    }
  }, []);

  const handleSubmit = async () => {
    const selectedBanks: any[] = Object.values(selectedRows).flat();
    let data = tablesData
      .filter((ele) => ele)
      .map((_ele: ConsolidateTableRowType, index: number) => {
        const { id, micr, neftIfsc, pincode, ...rest }: bankMandateProps =
          selectedBanks[index];
        return {
          amc: _ele.amc,
          amc_name: _ele.amcName,
          folio: String(_ele.folio),
          bankDetails: rest,
        };
      });
    const pan = props.investorData.PAN;
    try {
      let payload = {
        email: targetFunds[0].email,
        mobile: targetFunds[0].mobile,
        distributor_id: props.token,
        operationType: actionType,
        pan,
        data,
      };
      let res = await props.updateMultiBankDetails(payload);
      if (res?.status === 201) {
        props.history.replace("/new-transaction/nct-type/success", {
          state: {
            succesMessage: res.message,
          },
        });
      }
    } catch (err: any) {
      alert(err.message);
    }
  };

  const handleDeleteFolio = (index: number) => {
    const reducedData = tablesData.reduce(
      (prev: any, curr: any, ind: number) => {
        if (index === ind) {
          return [...prev, undefined];
        }
        return [...prev, curr];
      },
      []
    );
    const filteredDetails = tablesData.filter(
      (_ele: ConsolidateTableRowType, ind: number) => ind !== index
    );
    if (reducedData.filter((_ele) => _ele).length === 0) {
      props.history.replace("bank-mandate");
    }
    setTablesData(reducedData);
  };

  return (
    <div className="curved-bg">
      <BackArrow history={props.history} />
      <div className="curved-bg-content update-pan-selected-content">
        <div className="curved-bg-content-inner">
          <div className="curved-bg-content-inner-top">
            <p>{dashboard.BankMandate.selectedFolios.subheading}</p>
            {!!tablesData.length &&
              !!Object.keys(selectedRows).length &&
              tablesData.map(
                (fund: ConsolidateTableRowType, index: number) =>
                  !!fund && (
                    <div className="selected-folios-list">
                      <h3>{fund.amcName}</h3>
                      <a
                        className="delete-folio"
                        onClick={() => {
                          handleDeleteFolio(index);
                          setSelectedRows(
                            Object.keys(selectedRows).reduce(
                              (prev: any, curr: any, ind: number) => {
                                if (index === ind) {
                                  return { ...prev };
                                }
                                return {
                                  ...prev,
                                  [`table${ind}`]: selectedRows[curr],
                                };
                              },
                              {}
                            )
                          );
                        }}
                      >
                        <Image
                          src="/images/delete-folio.svg"
                          alt="delete icon"
                        />
                      </a>
                      <div className="selected-folios-list-bottom">
                        <p>
                          {dashboard.BankMandate.selectedFolios.primaryHolder}
                          <span>{fund.investorName}</span>
                        </p>
                        <p>
                          {dashboard.BankMandate.selectedFolios.ifsc}
                          <span>
                            {
                              fund.banks?.find(
                                (detail) => detail.default === "Y"
                              )?.ifsc
                            }
                          </span>
                        </p>
                        <p>
                          {dashboard.BankMandate.selectedFolios.bankName}
                          <span>
                            {
                              fund.banks?.find(
                                (detail) => detail.default === "Y"
                              )?.name
                            }
                          </span>
                        </p>
                        <p>
                          {dashboard.BankMandate.selectedFolios.folioNo}
                          <span>{fund.folio}</span>
                        </p>
                      </div>

                      <div className="bank-mandate-account-details">
                        <h5>
                          {actionType === CHANGE_DEFALUT
                            ? dashboard.BankMandate.selectedFolios
                                .chooseNewDefaultBank
                            : dashboard.BankMandate.selectedFolios
                                .chooseBankToDelete}
                        </h5>
                        <TableWithCollapse
                          rows={fund.banks
                            ?.filter((_ele: BANK) => _ele.default !== "Y")
                            .map((_detail) => ({
                              ..._detail,
                              id: _detail.accountNo,
                              investorName: fund?.investorName,
                            }))}
                          columns={Columns}
                          selectedRows={selectedRows[`table${index}`]}
                          setSelectedRows={(data: any) => {
                            setSelectedRows({
                              ...selectedRows,
                              [`table${index}`]: data,
                            });
                          }}
                          filteredData={filteredData}
                          radioGroupsEnabled
                        />
                      </div>
                    </div>
                  )
              )}
            {/* <div className="selected-folios-list">
                            <h3>Axis Liquid Direct Fund </h3>
                            <a className="delete-folio" href="#">
                                <img src="/images/delete-folio.svg" alt="delete icon" />
                            </a>
                            <div className="selected-folios-list-bottom">
                                <p>
                                    {dashboard.BankMandate.selectedFolios.primaryHolder}
                                    <span>Neha sagar</span>
                                </p>
                                <p>
                                    {dashboard.BankMandate.selectedFolios.ifsc}
                                    <span>0123456</span>
                                </p>
                                <p>
                                    {dashboard.BankMandate.selectedFolios.bankName}
                                    <span>AXIS BANK</span>
                                </p>
                                <p>
                                    {dashboard.BankMandate.selectedFolios.folioNo}
                                    <span>23XXXXXX454</span>
                                </p>
                            </div>
                            <div className="bank-mandate-account-details">
                                <h5>{dashboard.BankMandate.selectedFolios.chooseBankToDelete}</h5>
                                Table
                            </div>
                        </div> */}
          </div>
          <div className="curved-bg-content-inner-bottom">
            <Button
              onClick={handleSubmit}
              // href="/portal/nct/bank-mandate-success"
              className="customBtn"
              disabled={
                !Object.values(selectedRows).every((_ele: any) => !!_ele.length)
              }
              style={{ margin: "auto", marginTop: 30 }}
            >
              {dashboard.BankMandate.selectedFolios.buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer }: RootStateType) => ({ ...authReducer }),
  {
    updateMultiBankDetails,
  }
)(BankMandateDeleteSelected);
